import React from 'react'
import { Link } from "react-router-dom"

const Nav = () => {

    return (<>
        <ul className="dropdown-menu bg-primary w-300 pb-15">
            <li className="dropdown-header">
                <h4 className='color-warning'>Mengapa Kota Bekasi</h4>
            </li>
            <li role="separator" className="dropdown-divider"></li>
            <li><Link className="dropdown-item" to={'/mengapa-kota-bekasi/demografi'}>Demografi</Link></li>
            <li role="separator" className="dropdown-divider"></li>
            <li><Link className="dropdown-item" to={'/mengapa-kota-bekasi/geografis'}>Geografis</Link></li>
        </ul>
    </>)
}

export default Nav;